export const STORAGE_URL = 'https://cigsida.com/api/storage';

const SUPABASE_PUBLIC_URL_REGEX = /^https?:\/\/(?:[^/]+\.)?supabase\.co\/storage\/v1\/object\/public\/([^/]+)\/(.+)$/i;

export function normalizeStorageUrl(url) {
  if (!url || typeof url !== 'string') return url;
  if (url.startsWith('data:')) return url;
  if (url.startsWith(STORAGE_URL)) return url;

  const match = url.match(SUPABASE_PUBLIC_URL_REGEX);
  if (match) {
    const bucket = match[1];
    const path = match[2];
    const normalized = `${STORAGE_URL}/${bucket}/${path}`;
    if (normalized !== url) {
      console.warn('[storageUrl] Normalized Supabase public URL to cPanel storage URL', {
        original: url,
        normalized
      });
    }
    return normalized;
  }

  return url;
}

export function buildStoragePublicUrl(bucket, path) {
  if (!bucket || !path) return '';
  const cleanPath = path.startsWith('/') ? path.slice(1) : path;
  return `${STORAGE_URL}/${bucket}/${cleanPath}`;
}

export function resolveStorageUrl(url, bucket, path) {
  if (url) return normalizeStorageUrl(url);
  return buildStoragePublicUrl(bucket, path);
}
